import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  pageName: '',
}

const navBarSlice = createSlice({
  name: 'navBar',
  initialState,
  reducers: {
    setPageNameAction: (state, action) => {
      state.pageName = action.payload
    },
  },
})

export const { setPageNameAction } = navBarSlice.actions

export default navBarSlice.reducer
